export default __webpack_public_path__ + "static/media/email-icon.0fc46afe.svg";